function initProductComparisonTable() {
  const container = document.querySelector(".product-comparison-table__swiper");
  if (!container) return;

  const slides = Array.from(container.querySelectorAll(".product-comparison-table__slide"));

  new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: true,
    pagination: {
      el: ".product-comparison-table__pagination",
      clickable: true,
      renderBullet: function (index, className) {
        const color = (slides[index] && slides[index].dataset.accentColor) || "#171c8f";
        return `<span class="${className}" style="--pct-bullet-color: ${color};"></span>`;
      },
    },
  });
}

document.readyState !== "loading"
  ? initProductComparisonTable()
  : document.addEventListener("DOMContentLoaded", initProductComparisonTable);
